import { useEffect, useState } from 'react';

// Simple localStorage-backed state. Persists across reloads on this device only.
export function useLocalStorage<T>(key: string, initialValue: T) {
  const [value, setValue] = useState<T>(() => {
    try {
      const raw = window.localStorage.getItem(key);
      return raw ? (JSON.parse(raw) as T) : initialValue;
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Ignore write failures (quota exceeded / private mode).
    }
  }, [key, value]);

  return [value, setValue] as const;
}

export default useLocalStorage;
